import { SkuByCategory } from "../../../Interfaces/Product";

const sku_by_category: SkuByCategory = {
  "Custom 40oz Bottles": [550, 551, 552, 553, 555, 556],
  "Custom 20oz Bottles": [501],
  "Custom Tumblers": [651, 652, 653, 654, 655, 656],
  "Custom Travel Mugs": [601, 602, 603, 604, 605],
  Candies: [
    107, 108, 109, 110, 111, 120, 121, 122, 123, 124, 107001, 108001, 109001,
  ],
  Chocolates: [
    101, 110, 112, 113, 114, 120, 121, 122, 123, 125, 126, 207, 209, 212,
  ],
  Cookies: [301, 302, 303, 304],
  Nuts: [
    101, 102, 103, 104, 105, 106, 110, 111, 112, 115, 116, 118, 119, 124, 127,
    128, 129, 130, 131, 132, 133, 134, 302, 304, 106001, 116001, 118001,
  ],
  Popcorn: [201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212],
  "Custom Hoodies": [476, 478, 480, 482, 484, 486],
  "Custom T-Shirts": [450, 452, 454, 456, 458, 460],
  "Custom Racerbacks": [701, 705],
};

export default sku_by_category;
